// extracted by mini-css-extract-plugin
export default {"container":"ur-z","heading":"vr-z","text":"wr-z","info":"xr-z","link":"yr-z","fullMaxWidth":"zr-z"};